// Smooth Accordion Animation Logic
  document.querySelectorAll('.faq-question').forEach(button => {
    button.addEventListener('click', () => {
      const faqItem = button.parentElement;
      const container = faqItem.querySelector('.faq-answer-container');
      const isExpanded = faqItem.classList.contains('active');

      // Close all active items (Accordion mode)
      document.querySelectorAll('.faq-item.active').forEach(openItem => {
        if (openItem !== faqItem) {
          openItem.classList.remove('active');
          openItem.querySelector('.faq-answer-container').style.maxHeight = null;
        }
      });

      // Toggle clicked item
      if (isExpanded) {
        faqItem.classList.remove('active');
        container.style.maxHeight = null;
      } else {
        faqItem.classList.add('active');
        container.style.maxHeight = container.scrollHeight + "px";
      }
    });
  });

  // Search Filter Logic
  function filterFAQs() {
    const input = document.getElementById('faqSearch').value.toLowerCase().trim();
    const faqItems = document.querySelectorAll('.faq-item');
    const categories = document.querySelectorAll('.faq-category');
    let totalVisible = 0;

    faqItems.forEach(item => {
      const text = item.innerText.toLowerCase();
      const container = item.querySelector('.faq-answer-container');

      if (text.includes(input)) {
        item.style.display = 'block';
        totalVisible++;
      } else {
        item.style.display = 'none';
        item.classList.remove('active');
        container.style.maxHeight = null;
      }
    });

    // Hide empty categories during search
    categories.forEach(category => {
      const visibleChildItems = category.querySelectorAll('.faq-item[style*="display: block"]');
      if (input !== '' && visibleChildItems.length === 0) {
        category.style.display = 'none';
      } else {
        category.style.display = 'block';
      }
    });

    // Toggle No Results Block
    const noResults = document.getElementById('noResults');
    if (totalVisible === 0 && input !== '') {
      noResults.style.display = 'block';
    } else {
      noResults.style.display = 'none';
    }
  }

/* FAQ structured data for search engines, built from the questions and answers above */
  (function () {
    var items = document.querySelectorAll('.indaba-faq-wrapper .faq-item');
    if (!items.length || document.getElementById('indaba-faq-ld')) return;
    var qa = [];
    items.forEach(function (it) {
      var q = it.querySelector('.faq-question'), a = it.querySelector('.faq-answer');
      if (!q || !a) return;
      qa.push({ '@type': 'Question', name: q.textContent.replace(/\s+/g, ' ').trim(),
        acceptedAnswer: { '@type': 'Answer', text: a.textContent.replace(/\s+/g, ' ').trim() } });
    });
    var s = document.createElement('script');
    s.type = 'application/ld+json'; s.id = 'indaba-faq-ld';
    s.text = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: qa });
    document.head.appendChild(s);
  })();
